import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import { isIos } from "@/utils/lodash";
import Http from "@/api/http/fetch/index";

const Getters: GetterTree<any, any> = {
  [types.GETTER_MASTER_COINS](state, getters, rootState) {
    if (state.gxUserInfo.hasOwnProperty("coins")) {
      return state.gxUserInfo.coins;
    } else {
      return 0;
    }
  },
  [types.GETTER_MASTER_SERVICE_DATA](state, getters, rootState) {
    return state.gxUserInfo;
  },
  [types.GETTER_SERVICE_LIST](state, getters, rootState) {
    return state.gxServiceList;
  },
  [types.GETTER_SUBS_LIST](state, getters, rootState) {
    return state.subsList;
  },
  [types.GETTER_NATIVE_FREE_FOLLOWERS_ENABLE](state) {
    return state.freeFollowersEnable
  },
  [types.GETTER_VIP_VALID_COUNT](state, getters) {
    const userInfo: any = state.gxUserInfo
    if (!userInfo.vip_p_valid_time || userInfo.vip_p_valid_time < userInfo.server_current_time) {
      return getters[types.GETTER_VIP_TOTAL_COUNT]
    } else {
      return userInfo.vip_p_valid_count !== undefined ? userInfo.vip_p_valid_count : getters[types.GETTER_VIP_TOTAL_COUNT]
    }
  }
};

export default Getters;
